"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNotParentBindingConstraints = isNotParentBindingConstraints;
function isNotParentBindingConstraints(condition) {
    return (constraints) => {
        const ancestorMetadata = constraints.getAncestor();
        return ancestorMetadata === undefined || !condition(ancestorMetadata);
    };
}
//# sourceMappingURL=isNotParentBindingConstraints.js.map